import { render, staticRenderFns } from "./ChooseTable.vue?vue&type=template&id=4fd4c07b&scoped=true&"
import script from "./ChooseTable.vue?vue&type=script&lang=js&"
export * from "./ChooseTable.vue?vue&type=script&lang=js&"
import style0 from "./ChooseTable.vue?vue&type=style&index=0&id=4fd4c07b&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd4c07b",
  null
  
)

export default component.exports